import React from 'react';
import { CustomLabelMediumSmallBold, CustomLabelSmallMedium, 
  CustomLabelMediumRegularRedHatInto, CustomLabelSmallRegular,
  CustomLabelSmallMediumRegular } from '../../common/CustomLabel';
import { 
  Grid, 
  Typography, 
  // Button, 
  Card, 
  CardContent,
  Box,
  // Container
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Icons imports (you'll need to import your specific icons)
// import LAPTOP_DEV_MODE from "../../../assets/images/laptop-dev-mode.png";
// import ON_DEMAND_DEVELOPERS from "../../../assets/gif/OnDemandDeveloper.gif";
// import THINK from "../../../assets/services/think.png";
// import HAND_GRAPH from "../../../assets/services/hand-graph.png";
// import HAND_ROC from "../../../assets/services/hand-roc.png";
import BOX_ICON from "../../../assets/images/3d-center-box.png";
import PROJECT_BI_EQUITY from "../../../assets/gif/ProjectByEquity.gif";
import PARTNER from "../../../assets/services/partner.png";
import TEAMS from "../../../assets/services/Teams looking 2.png";
import EARLY from "../../../assets/services/Early-stage startups.png";

const StyledCard = styled(Card)(({ theme }) => ({
  background: '#F8F8F8',
  borderRadius: theme.spacing(2),
  height: '100%',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'translateY(-4px)',
    '& .MuiCardContent-root': {
            '& .benefit-icon': {
                filter: 'grayscale(0%)',
            },
        },
    '& .benefit-title': {
        filter: 'grayscale(100%)',
        transition: 'filter 0.3s ease',
    },
  }
}));

const BenefitIcon = styled(Box)(({ theme }) => ({
  color: '#5E17EB',
  marginBottom: theme.spacing(2),
  '& svg': {
    fontSize: '2rem',
  },
  filter: 'grayscale(100%)',
  transition: 'filter 0.3s ease',
}));

const ServicesOnDemandDevelopers = ({setShowProjectByEquity}) => {

    const LaptopIcon = () => {
        return (
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.33268 23.7034V6.66634C5.33268 4.82539 6.82507 3.33301 8.66602 3.33301H31.3327C33.1736 3.33301 34.666 4.82539 34.666 6.66634V23.7034M5.33268 23.7034H34.666M5.33268 23.7034L2.8655 32.4257C2.26373 34.5532 3.86206 36.6663 6.07299 36.6663H33.9257C36.1366 36.6663 37.735 34.5532 37.1332 32.4257L34.666 23.7034" stroke="#333333" stroke-width="2.5"/>
            <path d="M18.334 31.667L21.6673 31.667" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M23.3327 10.0003L26.666 13.3337L23.3327 16.667" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.6673 10.0003L13.334 13.3337L16.6673 16.667" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        )
    }

    const MonetizationOnIcon = () => {
        return (
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.26562 29.9997V16.6663C7.26562 14.8254 8.75801 13.333 10.599 13.333H19.2656H25.2656H33.9323C35.7732 13.333 37.2656 14.8254 37.2656 16.6663V29.9997C37.2656 31.8406 35.7732 33.333 33.9323 33.333H25.2656H19.2656H10.599C8.75801 33.333 7.26562 31.8406 7.26562 29.9997Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M31.4336 23.3497L31.4503 23.3312" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.0996 23.3497L13.1163 23.3312" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.26562 26.667H5.59896C3.75801 26.667 2.26562 25.1746 2.26562 23.3337V10.0003C2.26562 8.15938 3.75801 6.66699 5.59896 6.66699H28.9323C30.7732 6.66699 32.2656 8.15938 32.2656 10.0003V13.3337" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22.2663 26.6667C20.4253 26.6667 18.9329 25.1743 18.9329 23.3333C18.9329 21.4924 20.4253 20 22.2663 20C24.1072 20 25.5996 21.4924 25.5996 23.3333C25.5996 25.1743 24.1072 26.6667 22.2663 26.6667Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        )
    }

    const GroupIcon = () => {
        return (
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_43296_12921)">
            <path d="M1.86523 33.3333V31.6667C1.86523 25.2233 7.08858 20 13.5319 20V20C19.9752 20 25.1986 25.2233 25.1986 31.6667V33.3333" stroke="#333333" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M21.8652 23.3333V23.3333C21.8652 18.731 25.5962 15 30.1986 15V15C34.8009 15 38.5319 18.731 38.5319 23.3333V24.1667" stroke="#333333" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M13.5319 20.0003C17.2138 20.0003 20.1986 17.0156 20.1986 13.3337C20.1986 9.65176 17.2138 6.66699 13.5319 6.66699C9.85 6.66699 6.86523 9.65176 6.86523 13.3337C6.86523 17.0156 9.85 20.0003 13.5319 20.0003Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M30.1992 15C32.9606 15 35.1992 12.7614 35.1992 10C35.1992 7.23858 32.9606 5 30.1992 5C27.4378 5 25.1992 7.23858 25.1992 10C25.1992 12.7614 27.4378 15 30.1992 15Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_43296_12921">
            <rect width="40" height="40" fill="white" transform="translate(0.199219)"/>
            </clipPath>
            </defs>
            </svg>
            
        )
    }

    const SpeedIcon = () => {
        return (
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.1348 35H7.4681C5.62715 35 4.13477 33.5076 4.13477 31.6667V8.33333C4.13477 6.49238 5.62715 5 7.4681 5H34.1348C35.9757 5 37.4681 6.49239 37.4681 8.33333V23.3333" stroke="#333333" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M4.13477 11.667L37.4681 11.667" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.13477 8.34967L9.15143 8.33116" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.1348 8.34967L14.1514 8.33116" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.1348 8.34967L19.1514 8.33116" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M33.3014 36.667V26.667M33.3014 26.667L29.1348 30.8337M33.3014 26.667L37.4681 30.8337" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
        )
    }

    const HubIcon = () => {
        return (
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.73437 30C3.73437 32.7614 5.97295 35 8.73437 35C11.4958 35 13.7344 32.7614 13.7344 30C13.7344 27.2386 11.4958 25 8.73438 25C5.97295 25 3.73437 27.2386 3.73437 30Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M27.0664 30C27.0664 32.7614 29.305 35 32.0664 35C34.8278 35 37.0664 32.7614 37.0664 30C37.0664 27.2386 34.8278 25 32.0664 25C29.305 25 27.0664 27.2386 27.0664 30Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.4004 10C15.4004 12.7614 17.639 15 20.4004 15C23.1618 15 25.4004 12.7614 25.4004 10C25.4004 7.23858 23.1618 5 20.4004 5C17.639 5 15.4004 7.23858 15.4004 10Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M29.5664 25.8337L22.8997 14.167" stroke="#333333" stroke-width="2.5"/>
            <path d="M17.9004 14.167L11.2337 25.8337" stroke="#333333" stroke-width="2.5"/>
            </svg>

        )
    }

    
  const benefits = [
    {
      icon: <LaptopIcon />,
      title: 'Strategic Partnership',
      description: 'We go beyond funding — OSTRYX becomes a true partner, contributing both capital and deep industry expertise to help bring your vision to life.'
    },
    {
      icon: <MonetizationOnIcon />,
      title: 'Lower Upfront Cost',
      description: 'Reduce financial pressure with our Project By Equity Solutions. By exchanging equity for services, you minimize upfront costs and allocate resources where they matter most.'
    },
    {
      icon: <GroupIcon />,
      title: 'Long-Term Collaboration',
      description: `We’re committed to your success. Our model is built for sustainable, long-term relationships, ensuring you have ongoing support as your business grows.`
    },
    {
      icon: <SpeedIcon />,
      title: 'Expert Guidance',
      description: 'With our Equity-based Consulting Services, you gain access to seasoned professionals who will guide you through every stage of development, from strategy to execution.'
    },
    {
      icon: <HubIcon />,
      title: 'Shared Risk, Shared Reward',
      description: 'At OSTRYX, we invest in projects we believe in. By sharing both the risks and rewards, we are equally invested in achieving your success.'
    },
  ];

  const whatThis = [
    {
      icon: <img src={EARLY} alt="ROC" style={{ width: '100px', height: '100px' }} />,
      title : 'Bootstrapped Startups with High-Growth Potential',
      description: 'Big idea, low capital? Trade equity for OSTRYX’s funding and expertise to launch!'
    },
    {
      icon: <img src={PARTNER} alt="Clip Arrow" style={{ width: '100px', height: '100px' }} />,
      title : 'Tech & AI Innovators Disrupting Industries',
      description: 'Building AI or disruptive tech? Trade equity for custom solutions, expertise, and strategic partnerships!'
    },
    {
      icon: <img src={TEAMS} alt="Mesh" style={{ width: '100px', height: '100px' }} />,
      title : 'Founders Seeking Partners, Not Just Investors',
      description: 'Entrepreneurs need more than code—OSTRYX delivers strategy, branding, and execution for lasting success!'
    }
  ];

  return (
      <Grid container sx={{marginTop: {xs: "40px"}, px :{ xs: 1, md: 5}}}>
        <Grid item xs={12} md={7} sx={{padding: {xs: "20px", md: "40px 40px"}}}>
            <CustomLabelMediumSmallBold
                textAlign={ {xs:"center", md:"left"}}
                text={"Project by Equity"}
                color={"#5E17EB"}
            />
          <Typography  sx={{ my: 2 , fontSize: {xs: "16px", md: "20px"}, fontWeight: "500" ,  fontFamily: 'Red Hat Display',}}>
          Got a groundbreaking idea but limited funding? Let’s partner up.
          </Typography>
          <CustomLabelMediumRegularRedHatInto textAlign={"left"} normal={"1.5"} fontWeight={'400'} style={{ my: 4, mt: 8}}>
          At <b>OSTRYX</b>, we believe in bold ideas and innovative founders. Through our Project-by-Equity Solutions, we invest not just capital, but also our expertise, resources, and industry knowledge - in exchange for equity. This unique approach is ideal for startups and businesses with strong potential and a vision we can get behind.
          Our Project By Equity Investment model supports ventures at every stage, offering By Equity Consulting Services to help shape strategy and execution. From Project By Equity Development to Project By Equity Funding, we provide customized solutions designed to scale your business.
          Whether you're working on  disruptive technology or equity-based projects, we provide the technical expertise and development support needed to bring your vision to life. Let's create something exceptional together.

          </CustomLabelMediumRegularRedHatInto>
          <Grid item container sx={{
                    width: {xs: "100%", md: "35%"},
                    border: "1.5px solid #F5F5F5",
                    borderRadius: "20px",
                    padding: {xs: "10px 15px", md: "15px 25px"},
                    background: "#5E17EB", 
                    marginTop: "20px", 
                    cursor: "pointer",
                    transition: 'transform 0.2s ease',
                    alignItems: "center",
                    justifyContent: "center"
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents triggering parent hover effect
                  setShowProjectByEquity(true);
              }}>
                    <Grid item>
                <img src={BOX_ICON} alt={"BOX ICON"} />
                    </Grid>
                    <Grid item style={{marginLeft: "10px"}}>
                <CustomLabelSmallMedium text={"Discuss your Project Details!"} color="white"/>
            </Grid>
        </Grid>
          
        </Grid>

        <Grid item xs={10.5} md={4} sx={{padding: {xs: "20px", md: "20px 2px"},
                                    marginTop: {xs: "20px"},
                                    marginLeft: {xs: "20px"},
                                    display: "flex", 
                                    justifyContent: "center", 
                                    alignItems: "center",
                                    border: "1px solid #F5F5F5",
                                    borderRadius: 10,
                                    background: "#F5F5F5",
                                    }}>
            <img src={PROJECT_BI_EQUITY} alt={"PROJECT BY EQUITY"} style={{width: "100%", height: "100%"}} />
        </Grid>

        <Grid item xs={12} md={12} sx={{padding: {xs: "20px", md: "20px 40px"}}}>
            <Box sx={{ mt: 2 }}>
                <Grid item sx={{marginBottom: "20px", display : "flex" , justifyContent:"center"}}> 
                    <CustomLabelMediumSmallBold 
                    textAlign={ {xs:"center", md:"left"}}
                    text={"Key Benefits of Partnering with OSTRYX"} color="#5E17EB" />
                </Grid>
                <Grid container spacing={3}>
                {benefits.map((benefit, index) => (
                    <Grid item xs={12} sm={6} md={2.4} key={index}>
                    <StyledCard elevation={0}>
                        <CardContent>
                        <BenefitIcon>
                            {benefit.icon}
                        </BenefitIcon>
                        <Grid sx={{ marginBottom: "16px" }}>
                            <CustomLabelSmallMediumRegular
                                color="#5E17EB"
                                fontWeight="700"
                                normal="left"
                                text={benefit.title}
                            />
                            </Grid>
                            <CustomLabelSmallRegular
                                fontWeight="400"
                                normal="left"
                                color="#333333"
                                text={benefit.description}
                            />
                        </CardContent>
                    </StyledCard>
                    </Grid>
                ))}
                </Grid>
            </Box>
        </Grid>

        <Grid container sx={{padding: {xs: "20px", md: "40px 40px"}}}>
            <Box sx={{ mt: 8 }}>
                <Grid item sx={{marginBottom: "20px"}}> 
                    <CustomLabelMediumSmallBold  text={"Who this is for ?"} color="#5E17EB" />
                </Grid>
                <Grid container spacing={3}>
                {whatThis.map((whatThis, index) => (
                   <Grid item xs={12} sm={6} md={4} key={index}>
                   <StyledCard elevation={0}>
                   <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                       <BenefitIcon className="benefit-icon" sx={{ marginRight: 2 }}>
                           {whatThis.icon}
                       </BenefitIcon>
                       <Box gap={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                           <CustomLabelSmallRegular 
                               className="benefit-title"
                               textAlign="left" 
                               text={whatThis.title} 
                               fontWeight="700"
                               sx={{ filter: 'grayscale(100%)', transition: 'filter 0.3s ease' }}
                           />
                           <CustomLabelSmallRegular 
                               textAlign={"left"} 
                               text={whatThis.description} 
                               fontWeight={"400"}
                           />
                       </Box>
                   </CardContent>
                   </StyledCard>
                   </Grid>
                ))}
                </Grid>
            </Box>
        </Grid>

      </Grid>
  );
};

export default ServicesOnDemandDevelopers;